{% block sw_customer_detail_custom_field_sets %}
    {% parent() %}

    <mt-card
        :title="$t('neti-incomplete-order-reminder.sw-customer.detailBase.netiIncompleteOrderReminder')"
        :isLoading="customer.isLoading"
        class="neti-incomplete-order-reminder-consent"
        v-if="customer.id && customer.extensions.netiAllowIncompleteOrderReminder"
    >
        <template v-slot:headerRight>
            <neti-next-incomplete-order-reminder-config-icon pluginName="NetiNextIncompleteOrderReminder"/>
        </template>

        <sw-container
            columns="1fr auto"
            gap="10px"
        >
            <mt-checkbox
                v-if="customer.extensions"
                v-model:checked="customer.extensions.netiAllowIncompleteOrderReminder.allowConsent"
                :label="$t('neti-incomplete-order-reminder.sw-customer.detailBase.netiIncompleteOrderReminderLabel')"
                style="margin: 0"
                ref="netiIncompleteOrderReminderConsent"
                :disabled="!customerEditMode"
            >
            </mt-checkbox>
        </sw-container>

        <template v-slot:footer>
            <div class="sw-card__footer-slot">
                <neti-next-incomplete-order-reminder-powered-by pluginName="NetiNextIncompleteOrderReminder"/>
            </div>
        </template>
    </mt-card>
{% endblock %}